<template>
	<accordion>
		<panel title="DIMENCIONAMENTO"> DIMENCIONAMENTO ... </panel>
		<panel title="HIGIENE OCUPACIONAL"> HIGIENE OCUPACIONAL ... </panel>
	</accordion>
</template>
<script>
	import { accordion, panel } from 'app/accordion';
	export default {
		components: { accordion, panel },
	};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/sst/seguranca/components/mapRisco/map-components/mapeamento.vue